import { useState } from 'react'
import FooterWrapper from './footer.style'
import { ppLogo,
  MariBerasuransiLogo,
  OJKLogo,
  facebookLogo,
  instagramLogo,
  youtubeLogo,
  xLogo,
  linkedinLogo,
  phone,
  message,
  location,
  calendar,
  whatsapp,
  ArrowDown
} from '../../image'

const AppFooter = () => {
  const [openSections, setOpenSections] = useState({})

  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section]
    }))
  }

  return (
    <FooterWrapper data-testid='footer'>
      <div className='inner-container'>
        <div className='footer-top'>
          <div className='footer-top-items'>
            <img src={ppLogo} className='tap-insure-logo' />
            <p>PT Asuransi Untuk Semua merupakan Perusahaan Asuransi yang berizin dan diawasi oleh Otoritas Jasa Keuangan.<br /><strong>Nomor lisensi OJK No. KEP-56/D.05/2022</strong></p>
            <div className='aus-mariberasuransi'>
              <img src={OJKLogo} />
              <img src={MariBerasuransiLogo} />
            </div>
            <div className='socmed'>
              <a href='https://www.facebook.com/profile.php?id=100085662044998'><img src={facebookLogo} alt='Facebook Logo' /></a>
              <a href='https://www.instagram.com/tap.insure/'><img src={instagramLogo} alt='Instagram Logo' /></a>
              <a href='https://x.com/TapInsure_/'><img src={xLogo} alt='X Logo' /></a>
              <a><img src={youtubeLogo} alt='Youtube Logo' /></a>
              <a href='https://www.linkedin.com/company/tap-insurance/'><img src={linkedinLogo} alt='Linkedin Logo' /></a>
            </div>
          </div>
          <div className={`footer-top-items ${openSections['section1'] ? 'open' : ''}`}>
            <h2 onClick={() => toggleSection('section1')}>
            Hubungi Kami
              <div className={`arrow ${openSections['section1'] ? 'open' : ''}`}>
                <img src={ArrowDown} alt='Arrow Down' />
              </div>
            </h2>
            <ul>
              <li><a className='footer-with-logo clickable' href='tel:+622150847128'><img src={phone} /> +62 (21) 5084-7128</a></li>
              <li><a className='footer-with-logo clickable' href='mailto:Publicrelations@tap-insure.com'><img src={message} />publicrelations@tap-insure.com</a></li>
              <li><p className='footer-with-logo'><img src={location} />Gedung One Pacific Place Lantai 10 unit D - G Kawasan SCBD Jl. Jend. Sudirman Kav. 52-53 Jakarta Selatan 12190</p></li>
            </ul>
          </div>
          <div className={`footer-top-items ${openSections['section2'] ? 'open' : ''}`}>
            <h2 onClick={() => toggleSection('section2')}>
            Layanan Pelanggan
              <div className={`arrow ${openSections['section2'] ? 'open' : ''}`}>
                <img src={ArrowDown} alt='Arrow Down' />
              </div>
            </h2>
            <ul>
              <li><p className='footer-with-logo'><img src={calendar} /> Senin - Sabtu (09.00 - 21.00) <br />Minggu & Libur Nasional (Tutup)</p></li>
              <li><a className='footer-with-logo clickable' href='https://api.whatsapp.com/send/?phone=62818889019&text&type=phone_number&app_absent=0'><img src={whatsapp} /> <span><span className='underline-text'>0818 889 019</span> <br />Chat Only</span></a></li>
              <li><a className='footer-with-logo clickable' href='mailto:cs@tap-insure.com'><img src={message} /> <span className='underline-text'>cs@tap-insure.com</span></a></li>
            </ul>
          </div>
        </div>
        <div className='footer-bottom'>
          <p>&copy; 2024 TAP Insure. Hak cipta dilindungi Undang - undang.</p>
          <div className='privacy-policy'>
            <a href='https://tap-insure.com/kebijakan-privasi' className='clickable'>Kebijakan Privasi</a>
            <a href='https://tap-insure.com/syarat-dan-ketentuan' className='clickable'>Syarat & Ketentuan</a>
          </div>
        </div>
      </div>
    </FooterWrapper>)
}

export default AppFooter

// class AppFooter extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//         openSections: {}
//     };
//   }

//   toggleSection = (section) => {
//     this.setState((prevState) => ({
//       openSections: {
//         ...prevState.openSections,
//         [section]: !prevState.openSections[section],
//       },
//     }));
//   };

//   render () {

//   }
// }

// export default (AppFooter)
